import APIError from '../APIError';
class WithdrawError extends APIError {
    constructor(code, details = null) {
        super(code, 'WithdrawError', details);
    }
}
export default WithdrawError;
